export const setCookiesAccepted = (value) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("cookiesAccepted", value);
  }
};

export const cookiesAccepted =
  typeof window !== "undefined" && localStorage.getItem("cookiesAccepted");